import type { PitcherEnv } from '@sdk/interfaces'

export const DSR_MESSAGE = 'DSR_MESSAGE' as const

export const DSR_MESSAGE_TYPES = {
  ENV_CHANGED: 'dsr_env_changed',
} as const

export const DSR_API_TYPES = {
  DSR_REQUEST: 'DSR_REQUEST',
  DSR_RESPONSE: 'DSR_RESPONSE',
} as const

export const DSR_API_METHOD_TYPES = {
  GET_ENV: 'dsr_get_env',
  GET_FILE: 'dsr_get_file',
  GET_APP_CONFIG: 'dsr_get_app_config',
  CLOSE: 'dsr_close',
  DSR_EMBEDDABLE_READY: 'dsr_embeddable_ready',
} as const

export type DsrMessagePayloads = {
  [DSR_MESSAGE_TYPES.ENV_CHANGED]: DsrEnv
}

export type DsrRequest<Payload = any> = {
  id: string
  type: (typeof DSR_API_TYPES)['DSR_REQUEST']
  body: {
    type: (typeof DSR_API_METHOD_TYPES)[keyof typeof DSR_API_METHOD_TYPES]
    data: Payload
  }
}

export type DsrResponse<Response = any> = {
  id: string
  type: (typeof DSR_API_TYPES)['DSR_RESPONSE']
  body: Response
}

export type DsrMessage<Payload = any> = {
  id: string
  type: typeof DSR_MESSAGE
  body: {
    type: (typeof DSR_MESSAGE_TYPES)[keyof typeof DSR_MESSAGE_TYPES]
    data: Payload
  }
}

// TODO: Request / message payloads to the dsr via embeddable's iframe

// Responses / message payloads from the dsr
export type DsrEnv = Pick<PitcherEnv, 'mode' | 'launch_darkly' | 'client_type' | 'state'> & {
  pitcher?: {
    access_token?: string
  }
}
